// extracted by mini-css-extract-plugin
export default {"Content":"Content_Content__35iGg"};